import {Components} from '@mui/material';

import {Colors} from '@constants/colors.constants';

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    'buy-price': true;
    'buy-price-selected': true;
    document: true;
    noncompliance: true;
    'small-statistic': true;
    statistic: true;

  }
}

const cards: Components = {
  MuiCard: {
    styleOverrides: {
      root: (props) => ({
        ...(props.ownerState.variant === 'document' ? {
          alignItems: 'center',
          backgroundColor: props.ownerState.color === 'secondary' ? Colors.white : Colors.background,
          display: 'flex',
          flexDirection: 'column',
          height: 74,
          justifyContent: 'center',
          overflow: 'hidden',
          padding: 5,
          width: 74,
          '& > .MuiTypography-root:first-of-type': {
            marginTop: 5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
          },
          '& .MuiCardActionArea-focusHighlight': {
            backgroundColor: props.ownerState.color === 'secondary' ? Colors.white : Colors.background,
          },
        } : {}),
        ...(props.ownerState.variant === 'statistic' ? {
          alignItems: 'flex-start',
          borderBottom: props.ownerState['aria-selected'] ? `3px solid ${Colors.primary}` : undefined,
          backgroundColor: Colors.white,
          borderRadius: 4,
          boxShadow: 'none',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          justifyContent: 'flex-start',
          minHeight: 160,
          padding: 20,
          position: 'relative',
          '& .MuiCardActionArea-focusHighlight': {
            backgroundColor: Colors.white,
          },
        } : {}),
        ...(props.ownerState.variant === 'small-statistic' ? {
          alignItems: 'flex-start',
          backgroundColor: Colors.background,
          borderRadius: 4,
          boxShadow: 'none',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          padding: 10,
          position: 'relative',
        } : {}),
        ...(props.ownerState.variant === 'buy-price' ? {
          alignItems: 'center',
          backgroundColor: props.ownerState.color === 'secondary' ? Colors.white : Colors.background,
          display: 'flex',
          flexDirection: 'column',
          cursor: 'pointer',
          height: 74,
          justifyContent: 'center',
          overflow: 'hidden',
          padding: 5,
          width: '100%',
          '& > .MuiTypography-root:first-of-type': {
            marginTop: 5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
          },
          '& .MuiCardActionArea-focusHighlight': {
            backgroundColor: props.ownerState.color === 'secondary' ? Colors.white : Colors.background,
          },
        } : {}),
        ...(props.ownerState.variant === 'buy-price-selected' ? {
          alignItems: 'center',
          backgroundColor: props.ownerState.color === 'secondary' ? Colors.white : Colors.background,
          display: 'flex',
          flexDirection: 'column',
          height: 74,
          border: `4px solid ${Colors.primary}`,
          justifyContent: 'center',
          overflow: 'hidden',
          padding: 5,
          width: '100%',
          '& > .MuiTypography-root:first-of-type': {
            marginTop: 5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
          },
          '& .MuiCardActionArea-focusHighlight': {
            backgroundColor: props.ownerState.color === 'secondary' ? Colors.white : Colors.background,
          },
        } : {}),
      }),
    },
  },
  MuiCardActionArea: {
    styleOverrides: {
      root: (props) => ({
        ...(props.ownerState['aria-label'] === 'big-document' ? {
          alignItems: 'center',
          backgroundColor: Colors.background,
          borderRadius: 6,
          display: 'flex',
          flexDirection: 'column',
          height: 174,
          justifyContent: 'center',
        } : {}),
        ...(props.ownerState['aria-label'] === 'noncompliance' ? {
          alignItems: 'center',
          backgroundColor: Colors.white,
          display: 'flex',
          flexDirection: 'column',
          height: 54,
          justifyContent: 'center',
          padding: '0 10px',
          width: 'fit-content',
        } : {}),
        ...(props.ownerState['aria-label'] === 'week-day' ? {
          alignItems: 'center',
          backgroundColor: props.ownerState['aria-selected'] ? Colors.text : Colors.background,
          borderRadius: 4,
          color: props.ownerState['aria-selected'] ? Colors.white : Colors.text,
          display: 'flex',
          flexDirection: 'column',
          fontSize: 10,
          fontWeight: 400,
          height: 35,
          justifyContent: 'center',
          width: 35,
        } : {}),
      }),
      focusHighlight: (props) => ({
        ...(props.ownerState['aria-label'] === 'noncompliance' ? {
          backgroundColor: Colors.white,
        } : {}),
      }),
    },
  },
};

export default cards;
